import { signal } from "@preact/signals";
import type { User } from "../types";

/**
 * Global current user state.
 *
 * EXCEPTION: This is intentionally global mutable state to allow the user's
 * profile (name, photo, etc.) to update reactively across all components
 * without prop drilling. When the user updates their profile picture or name,
 * calling setCurrentUser() updates it everywhere (nav menu, account page, etc.).
 */
export const currentUser = signal<User | null>(null);

/**
 * Initialize or update the current user.
 * Call this when the user logs in or when user data is loaded.
 */
export function setCurrentUser(user: User | null): void {
  currentUser.value = user;
}

/**
 * Update the current user's profile picture URL.
 */
export function setCurrentUserProfilePicture(url: string | null): void {
  if (currentUser.value) {
    currentUser.value = {
      ...currentUser.value,
      profilePictureUrl: url,
    };
  }
}

/**
 * Update the current user's name.
 */
export function setCurrentUserName(name: string): void {
  if (currentUser.value) {
    currentUser.value = {
      ...currentUser.value,
      name,
    };
  }
}
